import { Palettes, LineTypes } from './SBPVisualizer';

import ScrewVertexShader from '../../shaders/screw/screw.vert';
import ScrewFragmentShader from '../../shaders/screw/screw.frag';

export default class SBPScrew extends THREE.Points {
  constructor (attrib, screwSegments, cutSegments, vbitSegments = null, millSize = 6.35) {
    const positions = [];
    const uvs = [];

    for (let i = 0, n = screwSegments.length; i < n; i++) {
      const s = screwSegments[i];
      if (s.start.z !== s.end.z && s.type === LineTypes.MOVE) {
        const i3 = (i * 3) * 2;
        const i2 = (i * 2) * 2;
        positions.push(attrib.positions[i3], attrib.positions[i3 + 1], attrib.positions[i3 + 2]);
        uvs.push(attrib.uvs[i2], attrib.uvs[i2 + 1]);
      }
    }

    const offset = screwSegments.length;

    for (let i = 0, n = cutSegments.length; i < n; i++) {
      const s = cutSegments[i];
      if (s.isPoint) {
        const ioff = i + offset;
        const i3 = (ioff * 3) * 2 + 3; // use latter one
        const i2 = (ioff * 2) * 2 + 2; // use latter one
        positions.push(attrib.positions[i3], attrib.positions[i3 + 1], attrib.positions[i3 + 2]);
        uvs.push(attrib.uvs[i2], attrib.uvs[i2 + 1]);
      }
    }

    if (vbitSegments) {
      const offset2 = offset + cutSegments.length;

      for (let i = 0, n = vbitSegments.length; i < n; i++) {
        const s = vbitSegments[i];
        if (s.isPoint) {
          const ioff = i + offset2;
          const i3 = (ioff * 3) * 2 + 3; // use latter one
          const i2 = (ioff * 2) * 2 + 2; // use latter one
          positions.push(attrib.positions[i3], attrib.positions[i3 + 1], attrib.positions[i3 + 2]);
          uvs.push(attrib.uvs[i2], attrib.uvs[i2 + 1]);
        }
      }
    }

    const geom = new THREE.BufferGeometry();
    geom.setAttribute('position', new THREE.BufferAttribute(new Float32Array(positions), 3));
    geom.setAttribute('uv', new THREE.BufferAttribute(new Float32Array(uvs), 2));
    // const material = new THREE.PointsMaterial( { color: Palettes[LineTypes.MOVE], size: 6.35 } )
    const material = new THREE.ShaderMaterial({
      vertexShader: ScrewVertexShader,
      fragmentShader: ScrewFragmentShader,
      transparent: false,
      // depthTest: false,
      // depthWrite: false,
      depthFunc: THREE.GreaterEqualDepth,
      uniforms: {
        color: { value: Palettes[LineTypes.MOVE].color },
        depth: { value: 0.35 },
        size: { value: millSize * 2 },
        t: { value: 1.0 }
      }
    });

    super(geom, material);
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/sbp/SBPScrew.js